import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import LolloBernie from './LolloBernie.js';
import { CardImage as CardImage$2, CardImageOverlay, Picture } from './CardImage.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import ConceptBadge from '../../ConceptBadge/ConceptBadge.js';
import CloudinaryPicture from '../../Picture/CloudinaryPicture.js';

var _excluded = ["image", "sizes", "externalImage", "lazy", "lolloBernie", "concept", "imageOverlay", "cardSettings", "onClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CardImage = function CardImage(_ref) {
  var image = _ref.image,
    sizes = _ref.sizes,
    _ref$externalImage = _ref.externalImage,
    externalImage = _ref$externalImage === void 0 ? null : _ref$externalImage,
    _ref$lazy = _ref.lazy,
    lazy = _ref$lazy === void 0 ? false : _ref$lazy,
    _ref$lolloBernie = _ref.lolloBernie,
    lolloBernie = _ref$lolloBernie === void 0 ? false : _ref$lolloBernie,
    _ref$concept = _ref.concept,
    concept = _ref$concept === void 0 ? null : _ref$concept,
    _ref$imageOverlay = _ref.imageOverlay,
    imageOverlay = _ref$imageOverlay === void 0 ? null : _ref$imageOverlay,
    cardSettings = _ref.cardSettings,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  var Picture$1 = externalImage !== null && externalImage !== void 0 ? externalImage : /*#__PURE__*/jsx(Picture, {
    as: CloudinaryPicture,
    img: image,
    sizes: sizes,
    retina: true,
    lazy: lazy
  });
  return /*#__PURE__*/jsxs(CardImage$2, _objectSpread(_objectSpread(_objectSpread({
    // @ts-ignore
    $sizes: sizes
  }, cardSettings), {}, {
    onClick: onClick
  }, rest), {}, {
    children: [Picture$1, /*#__PURE__*/jsxs(CardImageOverlay, _objectSpread(_objectSpread({}, cardSettings), {}, {
      children: [imageOverlay, /*#__PURE__*/jsx(ConceptBadge, {
        concept: concept,
        lazy: lazy
      }), lolloBernie && /*#__PURE__*/jsx(LolloBernie, {
        lazy: lazy
      })]
    }))]
  }));
};
var CardImage$1 = CardImage;

export { CardImage$1 as default };
//# sourceMappingURL=CardImage.js.map
